import React from 'react';
import PropTypes from 'prop-types';

export const Divider = ({children}) => <div className="form-divider"><span className="divider-text">{children}</span></div>;
Divider.propTypes = () => ({children: PropTypes.string.isRequired});
